import { onRequest, RequestMethod } from "common/axios/axios";
import { getApiUrl } from "common/axios/getApiUrl";

/**
 * 급번개(Flash Meetup) API
 * - /flash/**: 인증 필요 (추진자 전용)
 * - /flash/public/**: 공개 (비회원 접근 가능)
 */
export class FlashRepository {
    // 번개 생성
    static onPostCreate = (params: any) => {
        return onRequest({
            url: getApiUrl('flash'),
            method: RequestMethod.POST,
            params,
        });
    };

    // 내 진행중 번개 목록
    static onGetActive = () => {
        return onRequest({
            url: `${getApiUrl('flash')}/active`,
            method: RequestMethod.GET,
        });
    };

    // 최종 확정 → 모임 자동 생성
    static onPostDecide = (flashId: string, candidateId: string) => {
        return onRequest({
            url: `${getApiUrl('flash')}/${flashId}/decide`,
            method: RequestMethod.POST,
            params: { candidateId },
        });
    };

    // 취소
    static onPostCancel = (flashId: string) => {
        return onRequest({
            url: `${getApiUrl('flash')}/${flashId}/cancel`,
            method: RequestMethod.POST,
        });
    };

    // 회원 userNo 목록에게 초대 푸시 발송 (추진자 전용)
    static onPostInvite = (flashId: string, params: { inviteeUserNos: number[] }) => {
        return onRequest({
            url: `${getApiUrl('flash')}/${flashId}/invite`,
            method: RequestMethod.POST,
            params,
        });
    };

    // ========== 공개 엔드포인트 (비회원 가능) ==========

    // 번개 조회 (토큰 기반)
    static onGetByToken = (shareToken: string) => {
        return onRequest({
            url: `${getApiUrl('flash')}/public/${shareToken}`,
            method: RequestMethod.GET,
        });
    };

    // 투표
    static onPostVote = (
        shareToken: string,
        params: { candidateId: string; voterName: string; voterToken: string; voterUserNo?: number }
    ) => {
        return onRequest({
            url: `${getApiUrl('flash')}/public/${shareToken}/vote`,
            method: RequestMethod.POST,
            params,
        });
    };

    // 후보 제안
    static onPostAddCandidate = (shareToken: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('flash')}/public/${shareToken}/candidates`,
            method: RequestMethod.POST,
            params,
        });
    };
}
